import React from "react"

import { Box, SimpleGrid, Skeleton } from "@chakra-ui/react"
import { ProductListSkeleton } from "./ProductListSkeleton"
import Wrapper from "~/components/Wrapper"
import { useApplicationState } from "~/hooks/useApplicationState"

const OrderCompleteSkeleton: React.FC = () => {
  const { blockOrderSummaryAppInstallEnabled } = useApplicationState()

  const completeOrderRender = {
    col: { base: 1, md: 2 },
    mx: { lg: 10, "2xl": 28 },
    width: "auto",
    continueBtnAlign: { base: "center", md: "left" },
  }

  const missingAppBannerRender = {
    col: 1,
    mx: "auto",
    width: { base: "full", md: "70%", lg: "50%" },
    continueBtnAlign: "center",
  }

  const colRender = Boolean(blockOrderSummaryAppInstallEnabled)
    ? completeOrderRender
    : missingAppBannerRender

  return (
    <Wrapper pt={0} pb={16} px={4} color="gray.800">
      <Box display={{ base: "none", md: "block" }} mx={{ lg: 10, "2xl": 28 }}>
        <ProductListSkeleton />
      </Box>

      <SimpleGrid
        mx={colRender.mx}
        columns={colRender.col}
        width={colRender.width}
        spacing={4}
        display={{ base: "flex", md: "grid" }}
        flexDirection={{ base: "column-reverse", md: "row" }}
      >
        <Box>
          <Skeleton width="full" height={"390px"} />
        </Box>
        <Box>
          <Skeleton width="full" height={"586px"} />
        </Box>
      </SimpleGrid>

      <Box display={{ base: "block", md: "none" }}>
        <ProductListSkeleton />
      </Box>
    </Wrapper>
  )
}

export default OrderCompleteSkeleton
